import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { AddEmailTemplateRequest } from '../../../app/models/ss-api/requests/add.email.template.request';
import { TemplateTypes } from '../../../app/models/domain/email.template.item';
import { CKEditorComponent } from 'ng2-ckeditor';
import { Router } from '@angular/router';

export interface IAddEmailTemplateDialog {
    Title: string;
}

@Component({
    selector: 'add-email-template-dialog',
    styleUrls: ['./add.email.template.dialog.css'],
    templateUrl: './add.email.template.dialog.html'
})

export class AddEmailTemplateDialog extends DialogComponent<IAddEmailTemplateDialog, boolean> implements IAddEmailTemplateDialog, OnInit {
    IsBusy: boolean;
    Title: string;

    @ViewChild('CKEDITOR') CKEDITOR: CKEditorComponent;

    EmailName: string;
    EmailBody: string;
    EmailSubject: string;
    EmailType: TemplateTypes;
    EmailDescription: string;

    ToggleButtonTitle: string = 'Hide Fields';
    FieldsShown: boolean = true;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
    }

    ToggleFields() {
        this.FieldsShown = !this.FieldsShown;
        this.ToggleButtonTitle = this.FieldsShown ? 'Hide Fields' : 'Show Fields';
    }

    confirm() {
        this.IsBusy = true;

        if (this.CKEDITOR.instance['mode'] != 'wysiwyg') {

            this.CKEDITOR.instance['commands']['source'].exec()
            setTimeout(() => {
                this.confirm();
            }, 500)

            return false;

        }

        let request: AddEmailTemplateRequest = {
            Body: this.EmailBody,
            CustomDescription: this.EmailDescription,
            EmailTemplateName: this.EmailName,
            Subject: this.EmailSubject,
            TemplateType: this.EmailType
        }

        let disposable = this.api.AddEmailTemplate(request).subscribe(response => {
            this.IsBusy = false;

            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Template Added',
                    text: 'Template added successfully',
                    timer: 1500
                }).then(() => {
                    this.result = true;
                    this.close();
                }, () => { })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Template Not Saved',
                    text: response.Message,
                    timer: 1500
                }).then(() => { }, () => { })
            }

            disposable.unsubscribe();
        })
    }

}
